import type { MCPSharing } from "../../services/agent-tools-service";
import type { OrgUser } from "./hooks/useUsers";
import { requiresFullMcpAccess } from "./organizationAccess";

// BAD-1327 is scoped to per-user MCP permissions. Organization and project
// sharing keep their existing behaviour, while user-scoped connections only
// expose edit/delete actions to editors and owners. Legacy string recipients
// are viewers by definition.
export const canManageMcpConnection = (
  sharing: MCPSharing | null | undefined,
  currentUser: OrgUser | undefined,
): boolean => {
  if (requiresFullMcpAccess(currentUser)) return true;
  if (!sharing) return false;
  if (sharing.scope !== "user") return true;
  if (!currentUser) return false;

  const recipient = sharing.items.find((item) =>
    typeof item === "string"
      ? item === currentUser.id
      : item.id === currentUser.id,
  );

  if (!recipient || typeof recipient === "string") return false;
  return recipient.role === "editor" || recipient.role === "owner";
};
